import { render, staticRenderFns } from "./ThirdPartiesProjectTable.vue?vue&type=template&id=a629280a&"
import script from "./ThirdPartiesProjectTable.vue?vue&type=script&lang=js&"
export * from "./ThirdPartiesProjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports